import { render, staticRenderFns } from "./LayoutFront.vue?vue&type=template&id=670efe6c&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('670efe6c')) {
      api.createRecord('670efe6c', component.options)
    } else {
      api.reload('670efe6c', component.options)
    }
    module.hot.accept("./LayoutFront.vue?vue&type=template&id=670efe6c&", function () {
      api.rerender('670efe6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/layouts/LayoutFront.vue"
export default component.exports